import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__app_info } from '@shared/dto/app_info/DTO__app_info';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateAppInfo } from './state_app_info';

export const local_app_info_upsert = (payload: DTO__app_info): PayloadAction<DTO__app_info> => ({
  type: ENUM__redux_action.APP_INFO_UPSERT,
  payload,
});

export const init_local_app_info_upsert = (state: StateAppInfo, action: PayloadAction<DTO__app_info>) => {
  try_reload_window(state, state.app_info, action.payload);

  state.app_info = action.payload;
};

function try_reload_window(state: StateAppInfo, app_info_previous: DTO__app_info, app_info_current: DTO__app_info) {
  if (app_info_current.is_maintenance_mode_enabled() == app_info_previous.is_maintenance_mode_enabled()) return; //nothing changed for user
  if (app_info_current.is_maintenance_mode_enabled()) return; //no need to reload window during maintenance

  state.is_app_reloading = true;

  //reload page to update client
  window.location.reload();
}
